import { useQuery } from "@tanstack/react-query"
import { getDailyReport } from "api/accountReportApi"

export const ACCOUNT_DAILY_REPORT_QUERY_KEY = "account-daily-report"

export const useAccountDailyReport = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [ACCOUNT_DAILY_REPORT_QUERY_KEY, params],
    queryFn: () => getDailyReport(params),
    enabled,
  })
}
